import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { intercomSettings } from '../../types/services';
import { selectCurrentUser } from '../../store/modules/users/selectors';
import IntercomScript from './Intercom';
import lightHouseScript from './lightHouse';

const IntercomComponent = () => {
  const enable = process.env.REACT_APP_INTERCOM_ENABLE || '0';
  if (enable === '0') {
    return null;
  }

  return <Intercom />;
};

const InitIntercomAPI = (config: intercomSettings): void => {
  window.intercomSettings = { ...config };
  const intercom = window.Intercom;
  if (typeof intercom === 'function') {
    // intercom('reattach_activator');
    intercom('update');
  } else {
    IntercomScript(window.intercomSettings.app_id);
  }
};

const appId = process.env.REACT_APP_INTERCOM_ID || '';
const Intercom = () => {
  const currentUser = useSelector(selectCurrentUser);

  const user = currentUser.data
    ? {
      name: `${currentUser.data?.first_name} ${currentUser.data?.last_name}`,
      email: currentUser.data?.email,
    } : null;

  useEffect(() => {
    const config: intercomSettings = {
      app_id: appId,
      hide_default_launcher: false,
      ...user,
    };

    InitIntercomAPI(config);

    let isActiveLightHouse = false;
    if (user !== null) {
      isActiveLightHouse = true;
    }
    if (window.hdlh) {
      window.hdlh.isActiveLightHouse = isActiveLightHouse;
    }

    lightHouseScript();

    return () => {
      if (window.intercomSettings && window.Intercom) {
        window.intercomSettings.hide_default_launcher = true;
        window.Intercom('update');
      }
      if (window.hdlh) {
        window.hdlh.isActiveLightHouse = isActiveLightHouse;
      }
      window?.Lighthouse?.hideButton();
    };
  }, [user]);

  return null;
};

export default IntercomComponent;
